export namespace Validation {
    export const required = (value: any): null | string => Boolean(value) ? null : 'Questo campo è obbligatorio';
    export const email = (value: string): null | string => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) ? null : 'Inserisci un indirizzo email valido';
}

export function dateFormat(
    date: string,
    yearFormat: "numeric" | "2-digit" | null | undefined = "numeric",
    monthFormat: "numeric" | "2-digit" | "long" | "short" | "narrow" | null |undefined = "long",
    dayFormat: "numeric" | "2-digit" | null | undefined = "numeric"
) {
    let options: any = {}
    if (yearFormat) {
        options["year"] = yearFormat;
    }
    if (monthFormat) {
        options["month"] = monthFormat;
    }
    if (dayFormat) {
        options["day"] = dayFormat;
    }
    return (new Date(date)).toLocaleDateString(
        'it-IT',
        options
    );
}

export function dateDeltaFormat(
    dateStart: string,
    dateEnd: string,
    unit: "seconds" | "minutes" | "hours" | "days" = "days",
    monthFormat: "numeric" | "2-digit" | "long" | "short" | "narrow" | undefined = "long",
    dayFormat: "numeric" | "2-digit" | undefined = "numeric"
) {
    let A = new Date(dateStart);
    let B = new Date(dateEnd);
    let millisecond = Math.abs(A.getTime() - B.getTime());

    const seconds = millisecond / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;

    switch (unit) {
        case "seconds":
            return `${seconds} secondi`;
        case "minutes":
            return `${minutes} minuti`;
        case "hours":
            return `${hours} ore`;
        case "days":
            return `${days} giorni`;
    }
}

export function checkFunctionAsync(f: Function) {
    return f.constructor.name === "AsyncFunction";
}

export const debounce = (fn: (...args: any[]) => Promise<void>, delay: number) => {
    let timeout: any = undefined;
    return (...args: any[]) => {
        if (timeout) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

export function slugify(str: string) {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function svgToDataUri(svg: string): string {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}

export function getColoredMarkerSvg(color: string): string {
    return `
        <svg width="32" height="32" viewBox="0 0 8.466666 8.4666661" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-104.24583,-144.19792)">
            <path style="fill:${color};fill-opacity:1;stroke:#000000;stroke-width:0.27733;stroke-dasharray:none;stroke-opacity:1"
            d="m 108.85982,152.34799 c 0.82394,-1.03113 2.7031,-3.53027 2.7031,-4.93401 0,-1.7025 -1.38126,-3.08377 -3.08376,-3.08377 -1.70249,0 -3.08376,1.38127 -3.08376,3.08377 0,1.40374 1.87917,3.90288 2.70311,4.93401 0.19755,0.24574 0.56375,0.24574 0.76131,0 z m -0.38066,-5.96194 a 1.027925,1.027925 0 1 1 0,2.05585 1.027925,1.027925 0 1 1 0,-2.05585 z"
            />
        </g>
        </svg>
    `;
}

export const markers = {
    "red": svgToDataUri(getColoredMarkerSvg('#FF0000')),
    "green": svgToDataUri(getColoredMarkerSvg('#00FF00')),
    "blue": svgToDataUri(getColoredMarkerSvg('#0000FF')),
    "yellow": svgToDataUri(getColoredMarkerSvg('#FFFF00')),
    "magenta": svgToDataUri(getColoredMarkerSvg('#FF00FF')),
    "cyan": svgToDataUri(getColoredMarkerSvg('#00FFFF')),
    "brown": svgToDataUri(getColoredMarkerSvg('#800000')),
    "olive": svgToDataUri(getColoredMarkerSvg('#808000')),
    "darkGreen": svgToDataUri(getColoredMarkerSvg('#008000')),
    "purple": svgToDataUri(getColoredMarkerSvg('#800080')),
    "teal": svgToDataUri(getColoredMarkerSvg('#008080')),
    "darkBlue": svgToDataUri(getColoredMarkerSvg('#000080')),
    "orange": svgToDataUri(getColoredMarkerSvg('#FFA500')),
    "darkBrown": svgToDataUri(getColoredMarkerSvg('#A52A2A')),
    "blueViolet": svgToDataUri(getColoredMarkerSvg('#8A2BE2')),
    "black": svgToDataUri(getColoredMarkerSvg('#000000')),
    "white": svgToDataUri(getColoredMarkerSvg('#FFFFFF'))
}

